module.exports = __webpack_public_path__ + "static/image/company/pc/image_vision_1@3x.jpg?fac763b8";